import {THrefLangByLocale} from '../locale';
import {production as productionUrlMappings} from './production';

export const getProdHostnameByDevice = (
  hrefLangs: THrefLangByLocale[],
  device: 'mobile' | 'desktop',
): {[key: string]: string | undefined} => {
  const urlSetIndexByDevice = {
    desktop: 0,
    mobile: 1,
  };

  return hrefLangs.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.locale]:
        productionUrlMappings[curr.locale].urlSets[urlSetIndexByDevice[device]]
          ?.hostname,
    }),
    {},
  );
};
